// @ts-nocheck

// @index('./*.vue', (f, _) => `import { default as Joint${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as JointBuyNotice } from './buy_notice.vue'
import { default as JointInclusion } from './inclusion.vue'
import { default as JointRadio } from './radio.vue'
import { default as JointStar } from './star.vue'
import { default as JointStore } from './store.vue'
import { default as JointSubGoods } from './sub_goods.vue'
// @endindex

export const JointComponents = {
  // @index('./*.vue', (f, _) => `Joint${_.pascal(f.name)},`)
  JointBuyNotice,
  JointInclusion,
  JointRadio,
  JointStar,
  JointStore,
  JointSubGoods,
  // @endindex
}
